module.exports = __webpack_public_path__ + "img/xx.4f0521d4.svg";